import type { ReactNode } from "react";

type PhoneFrameProps = {
  children: ReactNode;
  className?: string;
};

export default function PhoneFrame({ children, className = "" }: PhoneFrameProps) {
  return (
    <div className={`rounded-[2rem] border-[3px] border-navy-900 bg-navy-900 ${className}`}>
      <div className="relative overflow-hidden rounded-[1.7rem] bg-white">
        {children}
        <span
          className="absolute bottom-1.5 left-1/2 h-1 w-14 -translate-x-1/2 rounded-full bg-navy-200"
          aria-hidden="true"
        />
      </div>
    </div>
  );
}